export enum PageTypeKey {
  Page = 'Page',
  SystemPage = 'SystemPage',
  MachineCategoryPage = 'MachineCategoryPage',
}
